import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Check } from '@material-ui/icons';
import { includes } from 'lodash';
import { GFO, ADM } from '~/constants/perfil';
import { UnidataTable } from '~/components';

import {  
  recordFiltering,
} from '~/store/modules/operacaoradaprovarprefatura/actions';

function OperacaoRadAprovarPreFaturaLista() {

  const { profile } = useSelector((state) => state.user);

  const [podeAprovar, setPodeAprovar] = React.useState(false);

  const buttons = [];

  const operacaoradaprovarprefatura = useSelector(
    (state) => state.operacaoradaprovarprefatura
  );

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (includes([ADM, GFO], profile.gloperfilid)) {      
        let pode = profile.glousua_aprova_pre_faturamento === 'S';
        setPodeAprovar(pode);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  const openWin = React.useCallback((url) => {
    window.open(
      url,
      '_blank',
      'toolbar=yes,scrollbars=yes,resizable=yes,top=1,left=1, fullscreen'
    );
  }, []);

  const aprovarPreFatura = React.useCallback((value) => {    
    openWin(value.fatu_link_prefatura);
  }, []);

  const header = useMemo(() => [
    {
      id: 'fatu_codigo',
      label: 'Pré-fatura',
      filter: {
        type: 'text',
      },
      align: 'left',
    },
    {
      id: 'fatu_periodo',
      label: 'Período',
      align: 'center',
    },
    {
      id: 'fatu_status_str',
      label: 'Status',
      align: 'center',
    },
  ], []);

  const headerbuttons = useMemo(() => [
    buttons.push({
      title: 'Aprovar Pre-fatura',
      action: (value) => aprovarPreFatura(value),
      icon: <Check />,
    }),
  ]);

  return (
    <>
      {podeAprovar && (

        <UnidataTable
          create={false}
          delete={false}
          update={false}
          fixed
          header={header}
          redux={operacaoradaprovarprefatura}
          read={recordFiltering}
          actions={buttons}
          detach="fatu_codigo"
        />

      )}
      {!podeAprovar && <h3>Usuário não pode aprovar pré-faturas</h3>}
    </>
  );
}

export default OperacaoRadAprovarPreFaturaLista;
